<template>
    <div class="min-h-screen">
        <InsuranceInfo
            v-if="showInfoModal"
            :ins-type="info.insType"
            :is-item="info.isItem"
            @close="closeInsInfo"
        />

        <div
            class="relative"
            :class="{'z-0': showInfoModal}"
        >
            <DialogBottom
                :title="combination.Title"
                :show-close-button="true"
                :show-header-divider="true"
                size="l"
                @close="onClose"
            >
                <div class="py-3 px-6 mt-0 max-w-4xl mx-auto xl:mt-5">
                    <div class="w-full mx-auto xl:w-7/12">
                        <div class="combo-image">
                            <img
                                v-if="combination.Image"
                                :src="`${combination.Image}`"
                                alt=""
                                class="rounded-2xl absolute w-full h-full object-cover object-center top-0 left-0"
                            >
                        </div>
                    </div>
                    <div class="text-[20px] mt-5 text-pink-800 font-bold text-center">
                        <span class="text-[16px]">參考價 $ </span>
                        {{ combination.InsPremium }}
                    </div>
                    <div
                        class="mt-6 text-left"
                        v-html="cleanHtml(combination.Content)"
                    >
                    </div>
                    <div
                        class="mt-4 text-justify text-pink-800"
                        v-html="cleanHtml(combination.Example)"
                    >
                    </div>
                    <div class="font-bold text-blue-700 text-[18px] text-center py-[15px] border-l-8 border-blue-700 bg-blue-500 mb-[40px] mt-[50px]">
                        特色 / 優勢
                    </div>
                    <div
                        class="mt-6 text-left"
                        v-html="cleanHtml(combination.Feature)"
                    >
                    </div>
                </div>

                <div class="py-6 px-5 max-w-4xl mx-auto">
                    <div class="font-bold text-blue-700 text-[18px] text-center py-[15px] border-l-8 border-blue-700 bg-blue-500 mb-[40px] mt-[50px]">
                        商品內容(範例)
                    </div>
                </div>
                <div
                    v-if="ready"
                    class="px-5 max-w-4xl mx-auto"
                >
                    <!-- Detail -->
                    <div class="max-w-4xl mx-auto">
                        <PolicyViewCompulsoryInsurance
                            class="overflow-hidden mb-4 rounded-2xl border-l border-r border-b border-blue-700"
                            :car-insures="combination.Insures"
                            @show-ins-info="showInsInfo"
                        />
                        <PolicyViewCarDamageInsurance
                            class="overflow-hidden mb-4 rounded-2xl border-l border-r border-b border-blue-700"
                            :car-insures="combination.Insures"
                            @show-ins-info="showInsInfo"
                            @show-is-item="showIsItem"
                        />
                        <PolicyViewBurglaryInsurance
                            class="overflow-hidden mb-4 rounded-2xl border-l border-r border-b border-blue-700"
                            :car-insures="combination.Insures"
                            @show-ins-info="showInsInfo"
                            @show-is-item="showIsItem"
                        />
                        <PolicyViewLiabilityInsurance
                            class="overflow-hidden mb-4 rounded-2xl border-l border-r border-b border-blue-700"
                            :car-insures="combination.Insures"
                            @show-ins-info="showInsInfo"
                            @show-is-item="showIsItem"
                        />
                        <PolicyViewOtherInsurance
                            class="overflow-hidden mb-4 rounded-2xl border-l border-r border-b border-blue-700"
                            :car-insures="combination.Insures"
                            @show-ins-info="showInsInfo"
                        />

                        <div class="border-blue-700 border-t-5 pt-6 pb-10 text-right flex justify-end">
                            <div class="text-right border-3 border-blue-700 rounded-md p-4 text-black w-full lg:w-1/3">
                                <div class="flex justify-between">
                                    <div class="text-blue-700 text-[18px] font-bold">
                                        參考價
                                    </div>
    
                                    <div class="text-[18px] text-gray-600">
                                        定價 ${{ IndirectPrem.toLocaleString('en-US') }}
                                    </div>
                                </div>
                                <div class="text-pink-800 text-[30px] text-right font-bold mt-4">
                                    ${{ InsPremium.toLocaleString('en-US') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <template v-if="faqs.length">
                    <hr class="mt-8 border-gray-400 border-top xl:hidden">
                    <div class="max-w-4xl px-6 mx-auto">
                        <div class="text-blue-700 text-[18px] text-center py-[15px] border-l-8 border-blue-700 bg-blue-500 mt-[50px]">
                            熱門問題
                        </div>
                    </div>
                    <HotFaq
                        :lists="faqs"
                        class="max-w-4xl mx-auto px-1 mt-4 text-left"
                    />
                </template>

                <div class="mt-4 pb-4 px-6 xl:pb-14">
                    <!-- Active -->
                    <div class="max-w-2xl mx-auto space-x-6 flex justify-center xl:space-x-20 xl:px-16">
                        <div
                            data-accuid="Popular_PopCal"
                            class="text-center rounded-full text-white text-[18px] py-2 bg-pink-800 cursor-pointer w-[140px] md:w-[214px]"
                            @click="onClickCalculate()"
                        >
                            試算我的保費
                        </div>
                    </div>
                    <!-- END Active -->
                </div>
            </DialogBottom>
        </div>
    </div>
</template>

<script>
import HotFaq from '@/components/HotFaq';
import DialogBottom from '@/components/DialogBottom';
import PolicyViewBurglaryInsurance from '@/components/policies/views/BurglaryInsurance';
import PolicyViewCarDamageInsurance from '@/components/policies/views/CarDamageInsurance';
import PolicyViewCompulsoryInsurance from '@/components/policies/views/CompulsoryInsurance';
import PolicyViewLiabilityInsurance from '@/components/policies/views/LiabilityInsurance';
import PolicyViewOtherInsurance from '@/components/policies/views/OtherInsurance';
import InsuranceInfo from '@/components/InsuranceInfo';

/**
 * 商品組合頁
 */
export default {
    name: 'CarCombination',
    components: {
        InsuranceInfo,
        PolicyViewOtherInsurance,
        PolicyViewLiabilityInsurance,
        PolicyViewCompulsoryInsurance,
        PolicyViewCarDamageInsurance,
        PolicyViewBurglaryInsurance,
        DialogBottom,
        HotFaq
    },
    beforeRouteEnter(from, to, next) {
        next(vm => {
            vm.back = to;
        });
    },
    metaInfo() {
        return {
            title: this.combination.Title || '商品組合推薦',
            meta: [
                {
                    name: 'description',
                    content: this.combination.Content || ''
                },
            ]
        };
    },
    data() {
        /**
         * @param {String} id 商品組合編號
         * @param {Object} back route 資訊
         * @param {Object} combination 商品組合資訊
         * @param {Array} faqs 熱門問題
         * @param {Object} info 險種介紹的險種編號或車險類別
         * @param {Boolean} ready 判斷是否完成資料寫入
         */
        return {
            id: null,
            back: {name: 'Home'},
            combination: {
                'InsCategory': this.$route.params.type === 'car'? 'Car' : 'Motorcycle',
                'Id': null,
                'Title': null,
                'Content': null,
                'Image': null,
                'Example': null,
                'Feature': null,
                'BrandID': null,
                'Model': null,
                'ProYear': 0,
                'Cylinder': 0,
                'CompelFactor': 0,
                'LiaFactor': 0,
                'CarDamageAccidentFactor': 0,
                'InsPremium': null,
                'Insures': [],
                'QuestionAndAnswer': []
            },
            faqs: [],
            info: {
                isItem: true,
                insType: null,
            },
            ready: false
        };
    },
    computed: {
        /**
         * 回傳加總的保費
         * 
         * @returns {Number} 加總的保額
         */
        InsPremium() {
            return _.sumBy(this.combination.Insures, 'InsPremium');
        },
        /**
         * 回傳加總的原始保費
         * 
         * @returns {Number} 加總的原始保額
         */
        IndirectPrem() {
            return _.sumBy(this.combination.Insures, 'IndirectPrem');
        },
        /**
         * 判斷是否開啟險種介紹的彈跳視窗，回傳 Null 不開啟，反之開啟相對內容
         * 
         * @returns {Number, String, Null}
         */
        showInfoModal() {
            return this.info.insType;
        },
        insTypes() {
            let arr=[];
            
            _.map(this.combination.Insures, i =>{
                arr.push(i.InsType);
            });
            return arr;
        }
    },
    async mounted() {
        this.pushDataLayerForPageView();
        await this.$insurance.setInsuresName();
        this.id = this.$route.params.id;
        this.loadInsCombination();
    },
    methods: {
        /**
         * 使用 DOMPurify 將傳入的 html 進行字串的清理，防止 XSS 攻擊
         *
         * @param {String} html 由 API 回傳商品組合資訊的 html 格式
         * @returns {String} 回傳處理過的 HTML 字串
         * @public
         */
        cleanHtml(html) {
            return DOMPurify.sanitize(html);
        },
        /**
         * 載入 API-InsCombination 商品組合的資料
         * 
         * @public
         */
        loadInsCombination() {
            axios.post(apiUrl.InsCombination, {
                id: parseInt(this.id)
            })
                .then(res => {
                    
                    if (!res.data.IsSuccess) this.$router.push({name: 'E404'});

                    this.combination = res.data.Data.InsCombination[0];
                    
                    for (let i = 0; i < this.combination.Insures.length; i++) {
                        if (this.combination.Insures[i]['InsType'] === '301' || this.combination.Insures[i]['InsType'] === '30') {
                            this.combination.Insures[i]['Deduct'] = this.combination.Insures[i]['Deduct'] < 4 ? 1 : 155;
                        }
                    }

                    this.faqs = _.map(this.combination.QuestionAndAnswer, o => {

                        let answer = o.Answer;

                        return {
                            question: o.Question,
                            answer: answer,
                            active: false,
                            id: o.ID
                        };
                    });

                    this.ready = true;

                }).catch(() => {
                    this.$router.push({name: 'E404'});
                });
        },
        /**
         * 點擊試算我的保費按鈕
         * 
         * @public
         */
        async onClickCalculate() {

            this.$store.commit('showLoading');

            await this.$store.dispatch('setPolicyInsures', this.combination.Insures);

            this.$store.commit('policy/setCombo', {
                comboId: this.combination.Id,
                name: this.combination.Title,
                comboPrice: this.combination.InsPremium
            });
            
            return this.$router.push(`/${this.$route.params.type}/calculator`);
        },
        /**
         * 將頁面導到指定的位置
         * 
         * @public
         */
        onClose(){
            if (this.back.name === 'Login' || this.back.name === 'Register') {
                return this.$router.push(`/${this.$route.params.type}`);
            }
            return this.$router.push(this.back);

        },
        /**
         * 載入險種介紹-險種的資料
         * 
         * @param {Boolean} isItem 是險種還是類別
         * @public
         */
        showIsItem(isItem) {
            this.info.isItem = isItem;
        },
        /**
         * 載入險種介紹-險種的資料
         * 
         * @param {String} insType 險種
         * @public
         */
        showInsInfo(insType) {
            this.info.insType = insType;
        },
        /**
         * 清除載入的險種介紹資料
         * 
         * @public
         */
        closeInsInfo() {
            this.info.isItem = true;
            this.info.insType = null;
        },
        /**
         * 推送GA4 DataLayer
         */
        pushDataLayer(type){
            let prem = _.sumBy(this.combination.Insures, 'InsPremium');
            let items = [];
            items.push({
                event: type,
                value: prem,
                item_id: this.combination.InsCategory + '-new',
                item_name: this.combination.InsCategory, 
                item_category: '新保',
                item_category2: '網路投保',
                item_list_id: this.combination.Id,
                item_list_name: this.combination.Title,
                price: prem
            });
            this.$ga.pushDataLayer(items);
        },
        /**
         * 推送GA4 DataLayer page_view
         */
        pushDataLayerForPageView(){
            let item = {
                pageUrl: window.location.href,
                pageTitle: document.title
            };
            this.$ga.pushDataLayerForPageView(item);
        }
    }
};
</script>

<style scoped>
.combo-image {
    width: 100%;
    position: relative;
    overflow: hidden;
    padding-bottom: 50%;
}
</style>